import React, { useContext } from "react";

export const BenchmarkContext = React.createContext<{
  isAll: boolean;
  exchange: string;
  setExchange: (key: string) => void;
  group: string[];
  setGroup: (key: string[]) => void;
  selectedKey: string[];
  setSelectedKey: (key: string[]) => void;
  investmentStyles: string[];
  groups: string[];
}>({
  isAll: false,
  exchange: "",
  setExchange: () => {},
  group: [],
  setGroup: () => {},
  selectedKey: [],
  setSelectedKey: () => {},
  investmentStyles: [],
  groups: []
});

export const useBenchmarkContext = () => useContext(BenchmarkContext);
